"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typo2_1 = require("../../../Typo2");
var __1 = require("../../../../..");
var CustomTooltip = function (props) {
    var active = props.active, payload = props.payload, value = props.value, showPercent = props.showPercent, mousePosition = props.mousePosition;
    if (!active || !payload || !payload.length)
        return null;
    // Calculate position - align with the right side of the bars
    var style = {
        position: 'fixed',
        left: "".concat((mousePosition === null || mousePosition === void 0 ? void 0 : mousePosition.x) || 0, "px"),
        top: "".concat((mousePosition === null || mousePosition === void 0 ? void 0 : mousePosition.y) || 0, "px"),
        transform: 'translate(10px, 10px)', // Offset from cursor and center vertically
        backgroundColor: __1.colors2.black,
        color: __1.colors2.white,
        border: "1px solid ".concat(__1.colors2.grey10),
        borderRadius: '6px',
        padding: '8px',
        boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.12)',
        zIndex: 1000,
        width: 'max-content',
        maxWidth: '200px',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        pointerEvents: 'none', // Add this to prevent tooltip from interfering with mouse events
    };
    return (react_1.default.createElement("div", { style: style },
        react_1.default.createElement("div", { style: {
                display: 'grid',
                gridTemplateColumns: showPercent ? 'auto auto auto' : 'auto auto',
                gap: '0.6rem'
            } },
            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1rem' } }, value.map(function (entry, index) { return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '0.6rem' } },
                react_1.default.createElement("div", { key: index, style: {
                        width: '1.2rem',
                        height: '1.2rem',
                        borderRadius: '50%',
                        backgroundColor: entry.color
                    } }),
                react_1.default.createElement(Typo2_1.UI_CAPTION_BOLD_DF, { key: index }, showPercent ? entry.percentage + '%' : (entry.count || '0')))); })),
            showPercent && (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1rem' } }, value.map(function (entry, index) { return (react_1.default.createElement(Typo2_1.UI_CAPTION_DF, { key: index }, entry.count || '0')); }))),
            react_1.default.createElement("div", { style: { paddingLeft: '0.8rem', display: 'flex', flexDirection: 'column', gap: '1rem' } }, value.map(function (entry, index) { return (react_1.default.createElement(Typo2_1.UI_CAPTION_DF, { key: index }, entry.tooltipLabel)); })))));
};
exports.default = CustomTooltip;
